var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSeoSettings24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_seo_settings24x24",
    transform: "translate(-2.996 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen",
    transform: "translate(2.996 -22)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46155",
    "data-name": "Path 46155",
    d: "M155.066,395.005h-1.16V392.8h-4.219V395h-1.16a.522.522,0,1,0,0,1.043h6.539a.522.522,0,1,0,0-1.043Z",
    transform: "translate(-142.797 -354.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46156",
    "data-name": "Path 46156",
    d: "M14.47,336l.179.177a.45.45,0,0,1,0,.636l-.3.3h0l-.3.3a.462.462,0,0,1-.643,0l-1.42-1.4H0v.869A1.225,1.225,0,0,0,1.23,338.1H16.77a1.225,1.225,0,0,0,1.23-1.23V336Z",
    transform: "translate(0 -299.223)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25180",
    "data-name": "Group 25180",
    transform: "translate(0 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46157",
    "data-name": "Path 46157",
    d: "M16.77,26H1.23A1.225,1.225,0,0,0,0,27.217v8.517H10.934L9.9,34.709a.443.443,0,0,1-.021-.612l-.5-.49a3.87,3.87,0,0,1-5.091-.3h0a3.772,3.772,0,0,1,0-5.371,3.869,3.869,0,0,1,5.432,0,3.769,3.769,0,0,1,.3,5.034l.5.49a.456.456,0,0,1,.619.021l2.278,2.253H18V27.217A1.225,1.225,0,0,0,16.77,26Z",
    transform: "translate(0 -26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46158",
    "data-name": "Path 46158",
    d: "M116.682,76.3a2.883,2.883,0,0,0,0,4.1,2.956,2.956,0,0,0,4.148,0,2.877,2.877,0,0,0,0-4.1,2.956,2.956,0,0,0-4.148,0Z",
    transform: "translate(-111.753 -73.731)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSeoSettings24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_seo_settings24x24.26d8cc2655581c4f10cdbd65122a00fe.svg";